import {
  CustomListEntryContainer,
  CustomListEntryContent,
  MainContentContainer,
  PrimaryText,
  SecondaryText,
} from '../../../CustomList/CustomList.styles';
import { DateBox } from '../DateBox/DateBox';
import { PrimaryContentContainer } from './ShiftDayEntry.styles';
import { getShiftSubtitle } from './getShiftSubtitle';
import { getScheduledHoursForDay } from '../../../../utils/shiftUtils';

const formatScheduledHours = (shifts) => {
  const totalHours = getScheduledHoursForDay(shifts);
  return totalHours > 0 ? `${totalHours} hours scheduled` : 'No shifts scheduled';
};

const ShiftDayEntry = ({ date, weatherIcon, isLast, shifts, employee, allShifts }) => {
  const { status, text } = getShiftSubtitle({ date, shifts, employee, allShifts });

  return (
    <CustomListEntryContainer>
      <CustomListEntryContent>
        <DateBox date={date} />
        <MainContentContainer isLast={isLast}>
          <PrimaryContentContainer>
            <PrimaryText variant="bodyRegular">{formatScheduledHours(shifts)}</PrimaryText>
            {weatherIcon}
          </PrimaryContentContainer>
          <SecondaryText variant="bodyRegular" status={status}>
            {text}
          </SecondaryText>
        </MainContentContainer>
      </CustomListEntryContent>
    </CustomListEntryContainer>
  );
};

export default ShiftDayEntry;
